// Vite inlines VITE_ vars at build time.
export const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  "https://backend.weconsultrx.com";
export const APP_URL =
  (import.meta.env.VITE_APP_URL as string | undefined) ??
  "https://app.weconsultrx.com";
export const SITE_URL = "https://weconsultrx.com";
